import React from "react";
import { SelectStrategyInput } from "./SubComponents/SelectStrategyInput";
import { TechnicalInputList } from "./SubComponents/TechnicalInutList";
import styles from "../../ProductConfigurationResultMainView.module.scss";
import { ExpandableSection } from "components/ProductConfigurator/components/Results/components/ExpandableSection";
import cx from "classnames";
import { useTranslate } from "hooks";
import { useProductOutput } from "stores/product";

export const TechnicalInputs = () => {
  const translate = useTranslate();
  const productOutput = useProductOutput();

  const isStrategyDisabled =
    (productOutput?.product?.availableStrategies?.length ?? 0) <= 1;
  const isInputsDisabled = !!productOutput?.product?.accessoryInfo;

  return (
    <ExpandableSection
      title={translate("PRODUCT_CONFIGURATOR_INPUT")}
      classNames={cx(
        styles.inputsCell,
        "d-flex flex-column border rounded" +
          " p-1 m-2" +
          " p-xxl-2 m-xxl-3" +
          " m-xxxl-4 me-xxxl-3 mb-xxxl-3",
      )}
    >
      <SelectStrategyInput isDisabled={isStrategyDisabled} />
      <TechnicalInputList disabled={isInputsDisabled} />
    </ExpandableSection>
  );
};
